import playerClient from "../middleware/playerClient";

export const SET_MPIN_ENDPOINT = "mpin/set";
export const RESET_MPIN_ENDPOINT = "mpin/reset";

export async function setPlayerMpin(payload) {
  const response = await playerClient.post(SET_MPIN_ENDPOINT, payload);
  return response.data;
}

export async function resetPlayerMpin(payload) {
  const response = await playerClient.post(RESET_MPIN_ENDPOINT, payload);
  return response.data;
}
